import { Component, Input, OnInit } from '@angular/core';
import { OrderItem } from 'src/app/api/contracts/order';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent implements OnInit {
  @Input() label: string = '';
  @Input() price: number = 0;
  @Input() amount: number = 1;
  @Input() compactPrice: boolean = false;

  constructor() {}

  ngOnInit() {
    return;
  }
}
